"use client"

import { useAppStoreContext } from "@/stores/appStore"
import { usePathname } from "next/navigation"
import { useEffect, useRef } from "react"

export function useWebPhoneViewStatusLogic({ isPopup }: { isPopup?: boolean }) {
  const pathname = usePathname()
  const setWebphoneExpanded = useAppStoreContext((s) => s.setWebphoneExpanded)
  const lastCheckedPath = useRef<string>(null)

  useEffect(() => {
    if (isPopup) return
    if (lastCheckedPath.current === pathname) return

    lastCheckedPath.current = pathname

    if (pathname.includes("/messenger")) {
      setWebphoneExpanded(true)
      return
    }

    if (pathname.includes("/power-dialer")) {
      setWebphoneExpanded(true)
      return
    }

    if (pathname.includes("/contact/")) {
      setWebphoneExpanded(true)
      return
    }

    if (pathname.includes("/scheduled/calls")) {
      setWebphoneExpanded(true)
      return
    }

    if (pathname.includes("/welcome")) {
      setWebphoneExpanded(false)
      return
    }

    // if (pathname.includes("/stats")) {
    //   setWebphoneExpanded(true)
    //   return
    // }

    setWebphoneExpanded(false)
  }, [isPopup, pathname, setWebphoneExpanded])
}
